import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { homepage, person } from '../data/site';
import HomeAvatar from '../components/HomeAvatar';

export default function Home() {
  const { hash } = useLocation();
  if (hash === '#ai-keyan') return <Navigate to="/experiments/ai-keyan" replace />;

  return (
    <article className="reading-page home-reading">
      <header className="personal-intro home-intro">
        <HomeAvatar />
        <div className="personal-identity">
          <h1>{person.name}</h1>
          <p className="personal-greeting">Hi, I'm Keyan.</p>
        </div>
      </header>

      <div className="personal-prose">
        <p>{homepage.intro}</p>
        <p>
          In my free time, I build my own projects and do AI and software consulting
          through <a href="https://orchestrategies.com">Orche Strategies</a>.{' '}
          <Link to="/projects">Things I'm building</Link>.
        </p>
      </div>

      <section className="personal-section margin-section" aria-labelledby="outside-title">
        <h2 className="margin-label" id="outside-title">Beyond work</h2>
        <div className="margin-content">
          <p>{homepage.outside}</p>
          <p>{homepage.offscreen}</p>
          <p>
            I think technology should give people more time and more say in how they
            live and work. <Link to="/ideas">A few ideas</Link>.
          </p>
        </div>
      </section>

      <section className="personal-section margin-section personal-contact" id="contact" aria-labelledby="contact-title" tabIndex={-1}>
        <h2 className="margin-label" id="contact-title">Say hello</h2>
        <div className="margin-content">
          <p>The easiest way to reach me is <a href={`mailto:${person.email}`}>{person.email}</a>.</p>
          <div className="personal-socials" aria-label="Elsewhere">
            <a href={`https://github.com/${person.github}`}>GitHub</a>
            <a href={`https://www.linkedin.com/in/${person.linkedin}`}>LinkedIn</a>
          </div>
        </div>
      </section>
    </article>
  );
}
